function wait(ms: number): Promise<void> {
  return new Promise((resolve): void => {
    setTimeout(resolve, ms);
  });
}

function getAPNSToken() {
  return new Promise((resolve): void => {
    // @ts-ignore
    window.FirebasePlugin.getAPNSToken(
      (apnsToken: string) => {
        resolve(apnsToken);
      },
      (error: string) => {
        console.warn(error);
        resolve(null);
      }
    );
  });
}

function getFcmTokenInner(): Promise<string | null> {
  return new Promise((resolve): void => {
    // @ts-ignore
    window.FirebasePlugin.getToken(
      (fcmToken: string): void => {
        resolve(fcmToken);
      },
      (error: Error): void => {
        console.warn(error);
        resolve(null);
      }
    );
  });
}

export async function getFcmToken(): Promise<string | null> {
  // @ts-ignore
  const firebasePlugin = window.FirebasePlugin;
  if (firebasePlugin === undefined) {
    return Promise.resolve(null);
  }
  return await new Promise((resolve, reject): void => {
    (async (): Promise<void> => {
      // iOS の場合、事前に APN トークンを取得しておく必要がある
      // APN トークンが利用可能でない場合は FCM トークンの取得時にエラーになるため、一定回数リトライすることでこれを回避する
      // https://firebase.google.com/docs/cloud-messaging/flutter/client?hl=ja#access_the_registration_token
      for (let i = 0; i < 5; i++) {
        // @ts-ignore
        if (window.device && window.device.platform === "iOS") {
          const apnsToken = await getAPNSToken();
          if (!apnsToken) {
            await wait(3000);
            continue;
          }
          console.log(`APNS token: ${apnsToken}`);
        }
        const fcmToken = await getFcmTokenInner();
        if (fcmToken) {
          console.log(`FCM token: ${fcmToken}`);
          resolve(fcmToken);
          return;
        }
        await wait(3000);
      }
      reject(new Error("Failed to get FCM token"));
    })();
  });
}
